'use strict';

angular.module('harriApp')
.controller('MemberInviteToApplyController', ["$scope", "$modal", "$state", "hUser", function ($scope,$modal,$state, hUser) {

    $scope.servedUser = publicConfiguration.publicData.userInfo;
    $scope.allMembers = [{
        id: $scope.servedUser.id,
        firstName: $scope.servedUser.first_name,
        lastName: $scope.servedUser.last_name,
        fullName : $scope.servedUser.first_name + " " + $scope.servedUser.last_name,
        profileImageUUID: $scope.servedUser.profile_image
    }];

    var modalData = function () {
        var brandId = hUser.getUserHighestBrandAccess().brand_id || hUser.getUserHighestBrandAccess().id;

        return {
            brandId: hUser.isTopLevelContext()? brandId: hUser.getUserContext().brand_id,
            candidates: $scope.allMembers,
            onHide: function () {
                $state.go("^");
            }
        };
    };

    $modal({
        controller: "InviteToApplyModal",
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/talent-pool/modals/invite-to-apply/invite-to-apply.modal.html',
        show: true,
        backdrop: 'static',
        resolve: {
            modalData: modalData
        }
    });
}]);
